/**
 * TDS rate calculation helpers (client-side).
 * Pure functions extracted from TDSImport.jsx.
 */

export const isCompanyPAN = (pan) => {
  if (!pan || pan.length < 4) return false;
  return pan.charAt(3).toUpperCase() === "C";
};

const RATES_BY_SECTION = {
  "194C": null, // varies by entity type
  "194J": 0.1,
  "194H": 0.05,
  "194I": 0.1,
  "194IA": 0.02,
  "194IB": 0.1,
  "194A": 0.1,
  "194D": 0.05,
  "194G": 0.05,
  "194K": 0.1,
  "194R": 0.1,
  "195": 0.2,
  "206C": 0.01,
  "206CA": 0.01,
  "206C(1)": 0.01,
  "206C(1F)": 0.01,
  "206C(1H)": 0.001,
};

export const getTDSRate = (section, pan) => {
  const sec = (section || "").toUpperCase();
  if (sec === "194C") return isCompanyPAN(pan) ? 0.02 : 0.01;
  return RATES_BY_SECTION[sec] ?? 0.1;
};

// Get expected TDS rate based on PAN entity type (194C rates)
// P=Individual, H=HUF -> 1%
// C=Company, F=Firm, A=AOP, T=Trust, B=BOI, G=Govt, J=Artificial, L=Local Authority -> 2%
export const getExpectedRateFromPan = (pan) => {
  if (!pan || pan.length < 4) return 0.01;
  const entityChar = pan.charAt(3).toUpperCase();
  if (entityChar === "P" || entityChar === "H") return 0.01;
  return 0.02;
};

// Get expense amount directly from Tally XML.
// Use the largest negative ledger amount (DBCLEDAMT) as the expense/base amount.
export const getExpenseAmountFromXML = (grossAmount, negativeAmounts) => {
  if (negativeAmounts && negativeAmounts.length > 0) {
    const amounts = negativeAmounts.map((a) => Math.abs(a)).filter((a) => a > 0);
    if (amounts.length > 0) {
      const maxAmount = Math.max(...amounts);
      return Math.round(maxAmount * 100) / 100;
    }
  }
  return grossAmount > 0 ? Math.round(grossAmount * 100) / 100 : 0;
};
